import { useBreakpoints } from '@vueuse/core'

const breakpoints = useBreakpoints({
  phone: 320,
  tablet: 640,
  desktop: 1280
})

const isVisibleScreen = (screen) => {
  return (breakpoints.current().value.includes(screen))
}

const currentScreen = () => {
  const isVisibleDesktop = isVisibleScreen('desktop')
  const isVisibleTablet = isVisibleScreen('tablet')
  const isVisblePhone = !isVisibleDesktop && !isVisibleTablet

  if (isVisblePhone) {
    return 'phone'
  }

  if (isVisibleDesktop) {
    return 'desktop'
  }

  if (isVisibleTablet) {
    return 'tablet'
  }
}

const visible = (el, binding) => {
  const values = Array.isArray(binding.value) ? binding.value : [binding.value]

  const visibleOn = values.filter(item => !item.startsWith('!'))
  const hiddenOn = values.filter(item => item.startsWith('!')).map(item => item.substr(1))
  const current = currentScreen()

  if (hiddenOn.length) {
    if (hiddenOn.includes(current)) {
      el.classList.add('!hidden')
    } else {
      el.classList.remove('!hidden')
    }
  } else {
    if (visibleOn.length) {
      if (visibleOn.includes(current)) {
        el.classList.remove('!hidden')
      } else {
        el.classList.add('!hidden')
      }
    }
  }
}

export { visible }
